import ServiceRequest from '../api/requests'
import AppointmentSlotServices from '../api/AppointmentSlots'
import PetService from '../api/PetService'

const actions = {
    Initialize: ({ commit }, bootdata) => {
        commit('Initialize', bootdata)
    },
    
    PracticeSelected({commit}, selectedPractice){
        commit('PracticeSelected',selectedPractice)
    },
    SetPageNumber({commit}, pageNumber){
        commit('SetPageNumber',pageNumber)
    },
    SetAppointmentType({commit}, isSickAppointment){
        commit('SetAppointmentType',isSickAppointment)
    },
    SetRequestedServices({commit}, services){
        commit('SetRequestedServices',services)
    },
    UpdateDistances: ({ commit }, latLang) => {
        commit('UpdateDistances',latLang)
    },
    InitializeState: ({commit})=> {
        var serviceRequest = new ServiceRequest();
        commit('ShowLoading', true);
        serviceRequest.getStates()
                .then(function (response) {
                    commit('ShowLoading', false);
                    commit('InitializeState', response.data)
                })
                .catch(function (error) {
                    commit('ShowLoading', false);
                    console.log(error);
                });
      
    },
    InitializeSpecies: ({commit}, selectedPractice)=>{
        var petService = new PetService();
        petService.getSpecies(selectedPractice.PracticeId).then(function (response) {
            commit('InitializeSpecies', response.data);
            commit('ShowLoading', false);
        })
        .catch(function (error) {
            commit('ShowLoading', false);
        });
    },
    FindMatchingPets:({commit, state}, bootdata)=>{
        commit('ShowLoading', true);
        var petService = new PetService();
        var matchingData = {
            FirstName: state.PetOwnerDetails.FirstName,
            LastName : state.PetOwnerDetails.LastName,
            Address: state.PetOwnerDetails.Address,
            Zip : state.PetOwnerDetails.Zip,
            EmailAddress : state.PetOwnerDetails.EmailAddress,
            Phone1: state.Phone,
            ClientPracticeId: state.SelectedClientPractice.PracticeId, 
        }
        return new Promise((resolve, reject) => {
            petService.getPets(matchingData).then(function (response) {
                resolve(response.data);
                commit('ShowLoading', false);
            })
            .catch(function (error) {
                resolve(null);
                commit('ShowLoading', false);
            });
        });
    },
    InitializeDueVaccine:({commit, state }, selectedPet)=> {
        if(state.NotificationId>0){
            selectedPet = state.SelectedPet;
        }
        commit('ShowLoading', true);
        var petService = new PetService();
        petService.getServices(selectedPet.PetId, state.SelectedClientPractice.PracticeId)
            .then(function (response) {
                commit('ShowLoading', false);
                commit('InitializeDueVaccine', response.data);
            })
            .catch(function (error) {
                commit('ShowLoading', false);
                console.log(error);
            });
    },
    ResetPracticeAvailableSlots:({commit, state }) => {
        commit('ResetPracticeAvailableSlots');
    },
    IncrementSlotPageNumber:({commit})=> {
        commit('IncrementSlotPageNumber')
    },
    GetPracticeAvailableSlots:({commit,state})=> {
        commit('ShowCalendarLoading', true);
        var slotService = new AppointmentSlotServices();
        var data = {
            ClientPracticeId:state.SelectedClientPractice.PracticeId, 
            PageNumber:state.SlotPageNumber,
            MinimumDayOut: state.SelectedClientPractice.FirstAppointmentStartInterval,
            IsSickAppointment : state.IsSickAppointment
        };
        slotService.getSlots(data )
        .then(function (response) {
            commit('ShowCalendarLoading', false);
            commit('SetPracticeAvailableSlots', response.data);
        })
        .catch(function (error) {
            commit('ShowCalendarLoading', false);
            console.log(error);
        });
    },
    SetAppointmentDay:({commit}, appointmentDay)=>{
        commit('SetAppointmentDay', appointmentDay)
    },
    SetAppointmentDateTime:({commit}, appointmentDateTime)=>{
        commit('SetAppointmentDateTime', appointmentDateTime)
    },
    InitializePets:({commit}, pets)=>{
        commit('InitializePets', pets)
        if(pets.length>0){
            commit('InitializePetOwner', pets[0])
        }
    },
    SetSelectedPet:({commit},pet)=> {
        commit('SetSelectedPet', pet)
    },
    ResetSelectedPet:({commit})=> {
        commit('ResetSelectedPet')
    },
    ResetStore:({commit})=>{
        commit('ResetStore')
    },
    ResetDate :({commit})=>{
        commit('ResetDate')
    },
    ResetServices :({commit})=>{
        commit('ResetServices')
    },
    BookAppointment:({commit, state})=>{
        commit('ShowLoading', true);
        var selectedVaccines = state.DueServices.filter(e=>e.Selected);
        var requestedServices = state.RequestedServices.filter(e=>e.Selected);
        var appointmentModel = {
            PracticeId: state.SelectedClientPractice.PracticeId,
            SelectPetId: state.SelectedPet!=null && state.SelectedPet.PetId>0? state.SelectedPet.PetId:null,
            PetVaccines: selectedVaccines,
            ClientPracticeRequestedService: requestedServices,
            AppointmentTimeSlot: state.SelectedAppointmentDateTime,
            Comments:  state.VisitComments,
            MinimumTime: state.SelectedAppointmentDateTime.MinimumTime,
            PetOwnerDetails : state.PetOwnerDetails,
            PetOwnerId: state.PetOwnerId,
            PetOwnerId_Ext: state.PetOwnerId_Ext,
            NewPetDetails: state.NewPetForm,
            IsSickAppointment: state.IsSickAppointment
        }
        return new Promise((resolve, reject) => {
            var slotService = new AppointmentSlotServices();
            slotService.bookAppointment(appointmentModel)
                .then(function (response) {
                    commit('ShowLoading', false);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('ShowLoading', false);
                    reject(error);
                });

        });
    }



}

export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js